import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { FlashSaleBar } from './components/FlashSaleBar';
import { HeroSection } from './components/HeroSection';
import { useMetaPixel } from './hooks/useMetaPixel';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { SaleNotifications } from './components/SaleNotifications';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const UniqueMechanism = lazy(() => import('./components/UniqueMechanism').then(m => ({
  default: m.UniqueMechanism
})));
const ProductHero = lazy(() => import('./components/ProductHero').then(m => ({
  default: m.ProductHero
})));
const TestimonialCarousel = lazy(() => import('./components/TestimonialCarousel').then(m => ({
  default: m.TestimonialCarousel
})));
const FAQAccordion = lazy(() => import('./components/FAQAccordion').then(m => ({
  default: m.FAQAccordion
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyCTA = lazy(() => import('./components/StickyCTA').then(m => ({
  default: m.StickyCTA
})));
function SectionLoader() {
  return <div className="w-full py-[40px] flex justify-center items-center" data-id="element-0">
      <div className="flex flex-col items-center gap-3" data-id="element-1">
        <div className="w-6 h-6 border-[2px] border-[#8B2500] border-t-transparent rounded-full animate-spin" data-id="element-2" />
      </div>
    </div>;
}
function ReadingProgressBar() {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = window.scrollY / totalHeight * 100;
      setWidth(progress);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 h-[3px] bg-transparent z-[1002] w-full" data-id="element-3">
      <div className="h-full bg-[#8B2500] transition-all duration-100 ease-out" style={{
      width: `${width}%`
    }} data-id="element-4" />
    </div>;
}
export function App() {
  useMetaPixel();
  useEffect(() => {
    document.title = 'Knee Geometry Advertorial';
    // Set heart emoji as favicon
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.font = '56px serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('❤️', 32, 36);
      const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = canvas.toDataURL();
      document.head.appendChild(link);
    }
  }, []);
  return <div className="min-h-screen bg-[#FAFAF7] text-[#1a1a1a] font-serif selection:bg-[#8B2500] selection:text-white" data-id="element-5">
      <ReadingProgressBar data-id="element-6" />
      <FlashSaleBar data-id="element-7" />

      <div className="max-w-[680px] mx-auto px-5 md:px-0 bg-[#FAFAF7] shadow-none" data-id="element-8">
        <HeroSection data-id="element-9" />

        <Suspense fallback={<SectionLoader data-id="element-11" />} data-id="element-10">
          <PainPoints data-id="element-12" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-14" />} data-id="element-13">
          <Benefits data-id="element-15" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-17" />} data-id="element-16">
          <UniqueMechanism data-id="element-18" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-20" />} data-id="element-19">
          <ProductHero data-id="element-21" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-23" />} data-id="element-22">
          <TestimonialCarousel data-id="element-24" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-26" />} data-id="element-25">
          <FAQAccordion data-id="element-27" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-29" />} data-id="element-28">
          <PricingSection data-id="element-30" />
        </Suspense>
      </div>

      <Suspense fallback={<SectionLoader data-id="element-32" />} data-id="element-31">
        <Footer data-id="element-33" />
      </Suspense>

      <Suspense fallback={null} data-id="element-34">
        <StickyCTA data-id="element-35" />
      </Suspense>

      <ExitIntentPopup data-id="element-36" />
      <SaleNotifications data-id="element-37" />
    </div>;
}